import 'react';
import { BsGrid } from '@react-icons/all-files/bs/BsGrid';
import { decorateComponent } from '../../documentComponents/decorateComponent.js';
import { getDisallowedAncestors } from '../../utils/ancestors.js';
import { jsx } from '@emotion/react';
import 'qs';
import 'query-string';
import { Grid as Grid$1 } from './Grid.js';
import { GridInspector } from './Inspector/index.js';

var Grid = decorateComponent(Grid$1, 'block', {
  id: 'grid',
  label: '그리드',
  defaultProps: {},
  allowedChildren: ['block', 'image', 'text', 'video', 'a', 'coupon', 'tab', 'carousel', 'html-template'],
  disallowedAncestors: getDisallowedAncestors(['grid']),
  renderIcon: function renderIcon() {
    return jsx(BsGrid, null);
  },
  renderInspector: GridInspector
});

export { Grid as default };
//# sourceMappingURL=index.js.map
